import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import styles from './CollegeCornerFilters.scss';
import { filterOptions } from './helpers';
import { getRecruitingStatusFilterLabel, RECRUITING_STATUS_FILTER } from '../pages/CollegeCornerJuniorProspects/cppConstants';

function CollegeCornerMobileFilters({
    filters,
    toggleModal,
    onClear,
    onApply,
    filterOptions: pageFilterOptions,
    sortingOptions: pageSortingOptions,
    searchTypes,
    validateFilters,
    customOptions,
    'data-testid': dataTestId,
}) {
    const [isMobileSortWindowOpen, setIsMobileSortWindowOpen] = useState(false);
    const [isMobileFilterWindowOpen, setIsMobileFilterWindowOpen] = useState(false);

    useEffect(() => {
        setIsMobileSortWindowOpen(false);
        setIsMobileFilterWindowOpen(false);
    }, [filters]);

    useEffect(() => {
        if (isMobileSortWindowOpen || isMobileFilterWindowOpen) {
            document.body.classList.add('no-scroll');
        } else {
            document.body.classList.remove('no-scroll');
        }
        return () => document.body.classList.remove('no-scroll');
    }, [isMobileSortWindowOpen, isMobileFilterWindowOpen]);

    const getSelectedValue = (type, value) => {
        if (type === 'division' && value) {
            const divisionList = customOptions ? customOptions.division : searchTypes.divisions;
            const selectedDivisionValue = divisionList.find((v) => v.value === value);
            return selectedDivisionValue.description;
        }

        if (type === 'conference' && value) {
            const conferences =
                searchTypes.conferences ? searchTypes.conferences : [];
            const selectedConferenceValue = conferences.find(
                (v) => v.value === value,
            );
            return selectedConferenceValue.description;
        }

        if (type === 'hsGradYears' && value) {
            const hsGradYearsSelectedTextMobile = Object.keys(value).filter(
                (v) => value[v],
            );
            return hsGradYearsSelectedTextMobile.length
                ? hsGradYearsSelectedTextMobile.join(', ')
                : '';
        }

        if (type === 'utrMin' && value) {
            return `${filters.utrMin.toFixed(1)} - ${filters.utrMax.toFixed(1)}`;
        }

        if (type === 'recruitingStatus') {
            return value && value !== RECRUITING_STATUS_FILTER.ALL
                ? getRecruitingStatusFilterLabel(value)
                : '';
        }

        return value;
    };

    // Validate the user permission and select filters for the page
    let countSelectedFilters = 0;
    const updatedFilterOptions = filterOptions
        .map((v) => {
            const emptyLabel = v.emptyLabel !== undefined ? v.emptyLabel : 'All';
            const defaultValue =
                (filters && getSelectedValue(v.value, filters[v.value])) || emptyLabel;
            if (defaultValue !== emptyLabel) { countSelectedFilters += 1; }
            const isVisible = v.value === 'hsGradYears' && !validateFilters
                ? false
                : v.isVisible;
            return { ...v, defaultValue, isVisible };
        })
        .filter(
            ({ modal, isVisible }) => pageFilterOptions.indexOf(modal) > -1 && isVisible,
        );

    const selectedFilterLabel = pageSortingOptions.find(
        (v) => v.value === filters?.sort,
    )?.label;

    return (
        <>
            <div className={`${styles.mblactionNav}`}>
                {pageSortingOptions.length ? (
                    <div className={`${styles.sort}`} data-testid={dataTestId && `${dataTestId}.sort-label`}>
                        SORT{' '}
                        <span className="link">
                            <span
                                onClick={(e) => {
                                    e.preventDefault();
                                    setIsMobileSortWindowOpen(true);
                                }}
                                data-testid={dataTestId && `${dataTestId}.sort-btn`}
                            >
                                {typeof selectedFilterLabel === 'function'
                                    ? selectedFilterLabel()
                                    : selectedFilterLabel}{' '}
                            </span>
                            <span
                                onClick={() => onApply({
                                    order: filters.order === 'asc' ? 'desc' : 'asc',
                                })}
                                className={`${filters.order === 'asc' ? styles.active : ''}`}
                                data-testid={dataTestId && `${dataTestId}.sort-direction-btn`}
                            >
                                <img src="/img/mbl-sorting-icon.svg" alt="" data-testid={dataTestId && `${dataTestId}.sort-direction-btn.icon`} />
                            </span>
                        </span>
                    </div>
                ) : (
                    <div />
                )}
                <div className={`${styles.filter}`}>
                    <span className="link" onClick={() => setIsMobileFilterWindowOpen(true)} data-testid={dataTestId && `${dataTestId}.filter-btn`}>
                        Filters{' '}
                        {countSelectedFilters > 0 && <span data-testid={dataTestId && `${dataTestId}.filter-count`}>({countSelectedFilters})</span>}
                    </span>
                    {countSelectedFilters > 0 && (
                        <button
                            type="button"
                            onClick={onClear}
                            className={`${styles.close}`}
                            data-testid={dataTestId && `${dataTestId}.clear-btn`}
                        >
                            <span className="closeButton" />
                            <span className="closeButton" />
                        </button>
                    )}
                </div>
            </div>

            <div
                className={`${styles.mblActions} ${isMobileSortWindowOpen ? styles.active : ''
                    }`}
                data-testid={dataTestId && `${dataTestId}.sort-panel`}
            >
                <div className={`${styles.mblHead}`}>
                    <div className={`${styles.title}`} data-testid={dataTestId && `${dataTestId}.sort-panel.title`}>Sort by</div>
                    <button
                        type="button"
                        onClick={() => setIsMobileSortWindowOpen(false)}
                        className={`${styles.close}`}
                        data-testid={dataTestId && `${dataTestId}.sort-panel.close-btn`}
                    >
                        <span />
                        <span />
                    </button>
                </div>
                <div className={`${styles.mblContent}`}>
                    {pageSortingOptions.map(({ label, value }) => (
                        <div
                            className={`${styles.item}`}
                            key={value}
                            onClick={() => onApply({
                                sort: value,
                            })}
                            data-testid={dataTestId && `${dataTestId}.sort-panel.item-${value}`}
                        >
                            <div
                                className={`${styles.playerName} ${filters?.sort === value ? styles.active : ''
                                    }`}
                            >
                                {typeof label === 'function' ? label() : label}
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            <div
                className={`${styles.mblActions} ${styles.filter} ${isMobileFilterWindowOpen ? styles.active : ''
                    }`}
                data-testid={dataTestId && `${dataTestId}.filter-panel`}
            >
                <div className={`${styles.mblHead}`}>
                    <div className={`${styles.title}`} data-testid={dataTestId && `${dataTestId}.filter-panel.title`}>Filters</div>
                    <button
                        type="button"
                        onClick={() => setIsMobileFilterWindowOpen(false)}
                        className={`${styles.close}`}
                        data-testid={dataTestId && `${dataTestId}.filter-panel.close-btn`}
                    >
                        <span />
                        <span />
                    </button>
                </div>
                <div className={`${styles.mblContent}`}>
                    {updatedFilterOptions.map(({ label, defaultValue, modal }) => (
                        <div
                            className={`${styles.item}`}
                            key={label}
                            onClick={() => toggleModal(modal)}
                            data-testid={dataTestId && `${dataTestId}.filter-panel.item-${modal}`}
                        >
                            <div className={`${styles.name}`} data-testid={dataTestId && `${dataTestId}.filter-panel.item-${modal}.label`}>{label}</div>
                            <div className={`${styles.all}`}>
                                <span data-testid={dataTestId && `${dataTestId}.filter-panel.item-${modal}.value`}>{defaultValue}</span>
                                <img src="/img/arrow-right-black.svg" alt="" data-testid={dataTestId && `${dataTestId}.filter-panel.item-${modal}.arrow`} />
                            </div>
                        </div>
                    ))}
                </div>
                <div className={`${styles.mblFooter}`}>
                    <div className={`${styles.btnWrap}`}>
                        <button
                            type="button"
                            className={`btn btn-lg btn-block btn-primary text-uppercase ${countSelectedFilters === 0 ? 'disabled' : ''
                                }`}
                            onClick={onClear}
                            data-testid={dataTestId && `${dataTestId}.filter-panel.clear-btn`}
                        >
                            Clear filters
                        </button>
                        <button
                            type="button"
                            className="btn btn-lg btn-block btn-primary text-uppercase"
                            onClick={onApply}
                            data-testid={dataTestId && `${dataTestId}.filter-panel.apply-btn`}
                        >
                            Apply filters
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
}

CollegeCornerMobileFilters.propTypes = {
    filters: PropTypes.instanceOf(Object),
    searchTypes: PropTypes.instanceOf(Object),
    customOptions: PropTypes.instanceOf(Object),
    validateFilters: PropTypes.instanceOf(Object),
    sortingOptions: PropTypes.instanceOf(Object),
    filterOptions: PropTypes.arrayOf(PropTypes.instanceOf(Object)),
    onClear: PropTypes.func,
    onApply: PropTypes.func,
    toggleModal: PropTypes.func,
    'data-testid': PropTypes.string,
};

CollegeCornerMobileFilters.defaultProps = {
    filters: null,
    searchTypes: null,
    customOptions: null,
    validateFilters: null,
    sortingOptions: null,
    filterOptions: [],
    toggleModal: () => { },
    onClear: () => { },
    onApply: () => { },
    'data-testid': null,
};

export default CollegeCornerMobileFilters;
